import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { injectGlobal } from 'styled-components';

// Load environment variables
// https://github.com/motdotla/dotenv/issues/133#issuecomment-255298822
import './env';

import configureStore from './store';
import App from './App';
import { darkGray } from './styles/styleVariables';
import mainFont from './fonts/AmcorPro-Light.ttf';
import titleFont from './fonts/AmcorPro-Book.ttf';

injectGlobal([
  `
  @font-face {
    font-family: 'AmcorPro Light';
    src: url(${mainFont}) format('truetype');
  }

  @font-face {
    font-family: 'AmcorPro Book';
    src: url(${titleFont}) format('truetype');
  }

  * {
    box-sizing: border-box;
    font-family: 'AmcorPro Light', sans-serif;
    margin: 0;
  }

  html {
    max-width: 100%;
    overflow-x: hidden;
  }

  body {
    padding: 0;
    margin: 0;
    color: ${darkGray};
    max-width: 100%;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'AmcorPro Light', sans-serif;
    font-weight: 300;
  }
`,
]);

injectTapEventPlugin();

const store = configureStore();

ReactDOM.render(<App store={ store } />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js